export class CoreError extends Error {
  public data: Record<string, unknown>;
  public date: Date;

  constructor(
    message: string,
    data: Record<string, unknown>,
    ...parameters: (ErrorOptions | undefined)[]
  ) {
    super(...[message, ...parameters]);

    if ("captureStackTrace" in Error) {
      (Error.captureStackTrace as (...args: unknown[]) => void)(
        this,
        CoreError,
      );
    }

    this.name = "CoreError";

    this.data = data;
    this.date = new Date();
  }
}
